<div class="mrd">
  <div class="mrd__header">
    <h2 class="mrd__title">{{ meetings?.length > 1 ? 'Upcoming meetings' : 'Upcoming meeting' }}</h2>
  </div>

  <div class="mrd__body">
    @for (meeting of meetings; track meeting?._id) {
      <div class="mrd__row">
        <span class="mrd__dot" [style.background]="getEventColor(meeting)"></span>

        <div class="mrd__info">
          <div class="mrd__time-line">
            <span class="mrd__time">{{ meeting?.start | date: 'shortTime' }} - {{ meeting?.end | date: 'shortTime' }}</span>
            <span class="mrd__countdown" [class.mrd__countdown--started]="hasStarted(meeting)">{{ getCountdownLabel(meeting) }}</span>
          </div>
          @if (getInviteeNames(meeting)) {
            <div class="mrd__invitees">{{ getInviteeNames(meeting) }}</div>
          }
          <div class="mrd__event-line">Meeting name <strong>{{ meeting?.name || 'Meeting' }}</strong></div>
        </div>

        @if (hasRelatedRecord(meeting)) {
          <button type="button" class="mrd__link" (click)="viewRelatedRecord(meeting)">{{ getRelatedRecordLinkLabel(meeting) }}</button>
        }
      </div>
    }
  </div>

  <div class="mrd__actions">
    <button type="button" class="mrd__btn mrd__btn--secondary" (click)="goToMeetings()">Go to Meetings</button>
    <button type="button" class="mrd__btn mrd__btn--primary" (click)="close()">Close</button>
  </div>
</div>
